import styles from './Toast.module.scss';

import { AnimatePresence, LazyMotion, domAnimation } from 'framer-motion';
import * as m from 'framer-motion/m';

import React from 'react';

interface Props {
  children: React.ReactNode;
}

export const Toast = ({ children }: Props) => {
  return (
    <AnimatePresence>
      <LazyMotion features={domAnimation}>
        <m.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ ease: 'easeOut', duration: 0.15 }}
          className={styles.toast}
        >
          <div className={styles.gradient} />
          <div className={styles.toastContent}>{children}</div>
        </m.div>
      </LazyMotion>
    </AnimatePresence>
  );
};
